'use strict';

function ReviewSet() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [];
  this.set = true;

  this.el = {};
  this._classes = {
    reviewSet: '.js--review-set',
    button: 'js--carousel-button',
    loading: '.js--loading-spinner',
    loaded: 'loading-spinner--fade-out'
  };

  this.init = function () {
    this.$node = $(this.node);
    this.el.reviewList = this.$node.find(this._classes.reviewSet);
    this.el.loading = this.$node.find(this._classes.loading);

    // MKTG-375: resolve to { items: [<matching review set>] } from local snapshot.
    var setId = this.set;
    var contentfulPromise = ContentSnapshots.findOne('reviewSet', function (item) {
      return item && item._id === setId;
    });

    var slickPromise = $.ajax({
      url: '/javascripts/slick.min.js',
      dataType: 'script'
    });

    $.when(contentfulPromise, slickPromise).then(this._loadContentful.bind(this)).then(this._loadCarousel.bind(this));
  };

  this.initAllReady = function () {
    this.el.loading.addClass(this._classes.loaded);

    this.$node.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', this._onLoadingComplete.bind(this));
  };

  this._loadContentful = function (contentfulData) {
    var _this = this;

    this.contentfulData = contentfulData;
    this.reviews = this.contentfulData.items[0].reviews;

    // prettier-ignore
    this.reviews = this.reviews.filter(function (item) {
      if (item._contentType.sys.id !== 'testimonialCustomer') return false;

      return _this.el.reviewList.append('<article class="review-component__review-container ' + (item.authorPicture ? 'review-with-picture-article' : 'review-no-picture-article') + '">' + '<div class="review-component__review">' + ('' + (item.authorPicture ? '<div class="review-component__picture-container">' + ('<img class="review-component__picture" srcset="' + item.authorPicture.file.url + ' 2x" alt="' + item.authorPicture.file.fileName + '">') + '</div>' : '')) + '<div class="review-component__content">' + ('<p class="review-component__quote">' + item.quote + '</p>') + '<div class="review-component__meta">' + ('<div class="review-customer__category" data-logo="' + _this._cleanCategory(item.category) + '"></div>') + '<div class="review-component__author-info">' + ('<h3 class="review-component__author">' + item.authorName + ' <span class="review-component__product">On ' + item.category + '</span>') + '</h3>' + '</div>' + '</div>' + '</div>' + '</div>' + '</article>');
    });
  };

  this._loadCarousel = function () {
    var _this2 = this;

    this.el.reviewList.slick({
      prevArrow: '<button type="button" class="review-component__previous ' + this._classes.button + ' js--carousel-button">Previous</button>',
      nextArrow: '<button type="button" class="review-component__next ' + this._classes.button + '">Next</button>',
      cssEase: 'ease-in-out'
    });

    // This removes the focus/hover style if you click, but not if you are using a keyboard
    this.el.reviewList.on('mouseup', '.' + this._classes.button, function () {
      this.blur();
    });

    // This pushes data to analytics for the intial review slide
    this._analyticsPush(this.set, this.el.reviewList.slick('slickCurrentSlide'), 'reviewOnLoad');

    // This pushes data to analytics for the last review slide the user saw
    this.el.reviewList.on('afterChange', function (event, slick, currentSlide) {
      _this2._analyticsPush(_this2.set, currentSlide, event.type);
    });

    this._retinaImagesFix();
  };

  this._analyticsPush = function (set, reviewIndex, eventType) {
    var review = this.reviews[reviewIndex];
    var data = {
      reviewSet: set,
      author: review.authorName,
      category: review.category,
      event: 'DLevent.' + eventType
    };
    dataLayer.push(data);
  };

  this._onLoadingComplete = function () {
    this.el.loading.remove();
  };

  this._cleanCategory = function (category) {
    return category.replace(/\s+/g, '').toLowerCase();
  };

  this._retinaImagesFix = function () {
    if (typeof picturefill === 'function') {
      picturefill();
    }
  };
}